<script>
import Countdown from "./Countdown";
import numberMixin from "@/mixins/numberMixin";

export default {
  mixins: [numberMixin],
  props: {
    payable: {
      type: [Object, Boolean],
      required: false,
      default: false
    }
  },
  components: {
    Countdown
  },
  methods: {
    timeIsUp() {
      this.$router.push({
        name: "order",
        params: { order_id: this.$route.params.order_id }
      });
    }
  }
};
</script>

<template>
  <section class="with-border">
    <div class="title">
      <div>
        <img src="/static/carrinho.svg" class="cart" />
      </div>
      <h2 v-if="payable.type === 'orders'" class="m-0 ml-20 keep-all">Finalizar compra</h2>
      <h2 v-else class="m-0 ml-20">Pagar Assinatura</h2>
    </div>

    <div v-if="payable.type === 'cycles'" class="pricing float text-right">
      <span class="price">{{payable.amount.total | intToCurrency}}</span>
    </div>

    <countdown
      v-if="payable.type === 'orders'"
      :initialTime="payable.created_at"
      @timeIsUp="timeIsUp()"
    />
  </section>
</template>

<style scoped>
.pricing {
  font-size: 30px;
  font-weight: bold;
}

.pricing .price {
  font-size: 30px;
  color: var(--pink);
  white-space: nowrap;
}

section {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

h2 {
  width: min-content;
  word-break: keep-all;
}

.cart {
  height: 65px;
}

.with-border {
  border-bottom: 1px solid #ddd;
}

.title,
.countdown {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.countdown div span {
  font-size: 14px;
}
.countdown div h1 {
  font-size: 45px;
  margin: 0;
}

@media (max-width: 768px) {
  section {
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .countdown {
    flex-direction: row;
    margin-bottom: 10px;
  }

  .title {
    margin-bottom: 5px;
  }

  h2 {
    font-size: 24px;
    width: auto;
  }

  .cart {
    height: 55px;
  }

  .countdown div span {
    font-size: 13px;
  }
  .countdown div h1 {
    font-size: 40px;
    margin: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/_Shared/Checkout/Payment/Header.vue